/* =============================================================================
   ROLVEA SIZE ADVISOR — v6
   =============================================================================

   COSA CAMBIA RISPETTO ALLA v5 — e perche'.

   La v5 chiedeva, su un paio di leggings: altezza, peso, vita, fianchi,
   forma del corpo, brand di riferimento e taglia in quel brand. Sette
   risposte, tre paragrafi di spiegazione, cinque righe di "perche'" nel
   risultato. Tre di quelle domande non reggevano:

   - la VITA veniva chiesta e poi buttata: sui capi bottom il motore legge
     ZONE_MEASURE = 'fianchi' e la vita non entra in nessun calcolo. Stesso
     difetto della coppa che valeva 0,5 contro una soglia che scartava 0,5.
   - il BRAND veniva da tabelle ricostruite con +/-1 taglia di margine:
     un'incertezza pari all'effetto massimo che poteva produrre.
   - la FORMA del corpo e' un segnale dedotto, non misurato, e da sola non
     spostava mai nulla: era interfaccia senza conseguenze.
   - la VESTIBILITA' preferita spostava una taglia intera su una preferenza
     estetica, producendo di proposito una taglia diversa da quella
     consigliata. Un secondo output, piu' debole, accanto al primo.

   Restano solo i dati che decidono davvero, e cambiano col capo:
     pantaloni / short / zampa -> altezza, peso, giro fianchi (facoltativo)
     top / magliette / giacche -> altezza, peso, taglia di reggiseno
     body / set                -> altezza, peso, reggiseno, giro fianchi

   E soprattutto: il widget adesso sa TACERE. Se la cliente e' fuori dalla
   tabella, o se i suoi dati portano a due taglie diverse, non stampa un
   numero: lo dice e passa il caso a noi. Meglio nessun consiglio che un
   consiglio sbagliato — e' la stessa regola per cui il widget non si
   renderizza se la serie non si risolve.

   FONTE DATI (unica ammessa): schede tecniche Teki delle serie 3003, 3006,
   8022 — matrici "尺码推荐" altezza x peso e tabelle "尺码表" misure capo.
   Pesi originali in 斤 (jin = 0,5 kg), qui gia' convertiti in kg.
   Nessun numero di questo file e' inventato.
   ========================================================================== */

(function () {
  'use strict';

  /* Cambia a ogni modifica della taratura: e' l'unico modo per separare,
     fra un mese, i resi degli ordini fatti con la versione vecchia da
     quelli fatti con questa. Viaggia sull'ordine come _sf_algo. */
  var ALGO = 'v6-core';
  var KEY = 'rlv_size_profile_v6';
  var LEGACY_KEYS = ['rlv_size_profile_v3', 'rlv_sf_profile_v1'];

  /* ---------------------------------------------------------------------
     1. MATRICI DEL FORNITORE  (altezza x peso -> taglia)
     Colonne peso in kg, passo 2,5 (= 5 jin). Righe altezza, passo 5 cm.
     Trascritte 1:1 da "尺码推荐" / "详情_09-10". E' una LOOKUP, mai una
     formula: 120/120 celle esatte, verificate dal collaudo.
     --------------------------------------------------------------------- */
  var W_COLS = [40, 42.5, 45, 47.5, 50, 52.5, 55, 57.5, 60, 62.5, 65, 67.5];
  var H_ROWS = [155, 160, 165, 170, 175];

  var MATRIX = {
    /* serie 3003 (Seconda Pelle) e 3006 (Line): scala XS-XL.
       Le due serie condividono la stessa scala: le tabelle misure capo
       coincidono capo per capo, quindi la matrice e' la stessa. */
    '3003': [
      ['XS', 'XS', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['XS', 'S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'M', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL', 'XL']
    ],
    /* serie 8022 (Costa): scala S-XL, la XS non esiste in produzione. */
    '8022': [
      ['S', 'S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'M', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL'],
      ['S', 'S', 'S', 'M', 'M', 'M', 'L', 'L', 'L', 'XL', 'XL', 'XL']
    ]
  };
  MATRIX['3006'] = MATRIX['3003'];

  var CEILING = 67.5;  /* ultima colonna della scheda: oltre, la tabella tace */
  var FLOOR = 40;      /* prima colonna della scheda */

  /* Oltre questi limiti l'altezza non si estrapola nemmeno quando il bordo
     della tabella e' piatto: e' un corpo troppo lontano dalle righe che
     abbiamo per fidarci di una riga di bordo. */
  var H_HARD_LO = 145;
  var H_HARD_HI = 190;

  /* ---------------------------------------------------------------------
     2. REGGISENO -> TAGLIA  (solo capi che toccano il petto)
     Verificata: scheda 8022 挂脖文胸, colonna 罩杯.
       S/8  -> 65BCD, 70ABC     L/12 -> 75D, 80ABC
       M/10 -> 70D, 75ABC       XL/14 -> 80D, 85ABC
     Su 3003/3006 quella colonna NON esiste: li' il reggiseno corregge, non
     decide, e la correzione passa da CUP_BIAS.
     --------------------------------------------------------------------- */
  var BRA_BANDS = [65, 70, 75, 80, 85, 90];
  var BRA_CUPS = ['A', 'B', 'C', 'D', 'E', 'F'];
  var BRA_MAP_8022 = {
    '65B': 'S', '65C': 'S', '65D': 'S', '70A': 'S', '70B': 'S', '70C': 'S',
    '70D': 'M', '75A': 'M', '75B': 'M', '75C': 'M',
    '75D': 'L', '80A': 'L', '80B': 'L', '80C': 'L',
    '80D': 'XL', '85A': 'XL', '85B': 'XL', '85C': 'XL'
  };

  /* La coppa come scostamento dalla taglia della matrice.
     Serve dove la colonna 罩杯 non e' pubblicata, cioe' ovunque tranne
     8022-BR: la matrice altezza/peso non sa niente del seno e a parita' di
     corpo darebbe la stessa taglia a una prima e a una quinta.

     ⚠️ Nessun valore coincide con STEP_THRESHOLD. Era il difetto di due
     versioni fa: la coppa valeva esattamente 0,5 e la soglia scartava
     <= 0,5, quindi il campo veniva chiesto, compilato e buttato. In fondo
     al file c'e' una guardia che lo rileva.

     🔴 NON si puo' riusare la mappa 8022 su 3003/3006: sono capi diversi
     (bralette da 14,5 cm contro halter lungo 43,5 cm) e le scale del petto
     non coincidono — 8022 S ha lo stesso petto di 3003 M. */
  var CUP_BIAS = { A: -0.3, B: 0, C: 0.3, D: 0.7, E: 1.1, F: 1.4 };

  function cupOf(bra) { return String(bra || '').replace(/[^A-Z]/g, ''); }
  function bandOf(bra) { return parseInt(String(bra || '').replace(/[^0-9]/g, ''), 10) || 0; }

  /* La tabella 8022 copre 18 combinazioni, i menu ne offrono 36: mancano
     le coppe E/F, la banda 90 e la 85D. Si completano con la regola delle
     taglie sorelle (una coppa in piu' = cinque centimetri di banda in
     meno), che e' la STESSA con cui il fornitore ha costruito i suoi
     gruppi: la sua M e' {70D, 75A, 75B, 75C} e 70D e' esattamente la
     sorella di 75C. Senza, si creano inversioni: una 85D riceveva una
     taglia piu' piccola di una 85C. */
  function bra8022(bra) {
    var band = bandOf(bra), ci = BRA_CUPS.indexOf(cupOf(bra));
    if (!band || ci < 0) return null;
    var dIdx = BRA_CUPS.indexOf('D');
    while (ci > dIdx) { band += 5; ci -= 1; }
    var hit = BRA_MAP_8022[band + BRA_CUPS[ci]];
    if (hit) return hit;
    if (band <= 65) return 'S';    /* sotto la tabella: la piu' piccola */
    return 'BEYOND';               /* sopra: il capo non ci arriva */
  }

  /* Soglia di scatto: serve piu' di mezza taglia di scostamento per
     muoversi dalla cella della tabella. Cosi' la matrice resta l'ancora. */
  var STEP_THRESHOLD = 0.5;
  var MAX_OFFSET = 2;

  /* Fin dove ci si fida di una misura dichiarata, in taglie di scostamento
     dall'attesa. Oltre una taglia e mezza (circa 10 cm sul fianco) la
     spiegazione piu' probabile non e' un corpo fuori media: e' il metro
     messo nel punto sbagliato. */
  var MEAS_TRUST = 1.5;

  function stepFromOffset(o) {
    o = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, o));
    if (Math.abs(o) <= STEP_THRESHOLD) return 0;
    return o > 0 ? Math.floor(o + 0.5) : -Math.floor(-o + 0.5);
  }

  /* ---------------------------------------------------------------------
     3. CAPI: che zona del corpo comanda, e quindi che cosa si chiede.
     bottom = leggings, short, zampa      -> giro fianchi
     top    = reggiseno, canotta, t-shirt, giacca -> taglia di reggiseno
     full   = body, set                   -> reggiseno + giro fianchi
     --------------------------------------------------------------------- */
  var GARMENT_ZONE = {
    CK: 'bottom', DK: 'bottom', ZA: 'bottom',
    BR: 'top', VE: 'top', MC: 'top', GZ: 'top',
    BD: 'full', SET: 'full'
  };

  /* Quale misura del corpo comanda, per zona. Il campo che si mostra alla
     cliente DEVE essere questo e nessun altro: chiedere una misura che il
     motore non legge e' il difetto che questa versione chiude. */
  var ZONE_MEASURE = { bottom: 'fianchi', top: null, full: 'fianchi' };

  /* ---------------------------------------------------------------------
     MISURE DEL CAPO — tabelle 尺码表 del fornitore, in centimetri.
     Misure A CAPO DISTESO, maglia non tesa: non sono misure del corpo.
     Si MOSTRANO cosi' come sono — e' l'unico numero del sistema senza
     nessuna stima dentro, e l'unico che la cliente puo' verificare da sola
     con un metro.
     Non si usano come metro assoluto: la conversione disteso -> corpo ha
     bisogno di un fattore di allungamento che nessun documento dichiara, e
     il risultato ci e' ipersensibile (100 cm di fianchi danno XL a 1,25,
     L a 1,30, M a 1,40, S a 1,45). Per questo la misura della cliente entra
     come SCOSTAMENTO dal previsto (vedi expectedBody) e mai in assoluto:
     l'errore del modello c'e' in entrambi i termini e si annulla.
     --------------------------------------------------------------------- */
  var GARMENT_MEASURES = {
    '3003-CK': { vita: [52, 56, 60, 64, 68], fianchi: [66, 70, 74, 78, 82] },
    '3003-DK': { vita: [52, 56, 60, 64, 68], fianchi: [66, 70, 74, 78, 82] },
    '3003-ZA': { vita: [51, 56, 61, 66, 71], fianchi: [65, 70, 75, 80, 85] },
    '3003-BR': { petto: [56, 60, 64, 68, 72] },
    '3003-VE': { petto: [64, 69, 74, 79, 84] },
    '3003-MC': { petto: [63, 68, 72, 76, 80] },
    '3003-GZ': { petto: [64, 68, 72, 76, 80] },
    '3003-BD': { petto: [61, 66, 71, 76, 81], fianchi: [64, 69, 74, 79, 84] },
    '3006-CK': { vita: [52, 56, 60, 64, 68], fianchi: [64, 68, 72, 76, 80] },
    '3006-DK': { vita: [52, 56, 60, 64, 68], fianchi: [64, 68, 72, 76, 80] },
    '3006-BR': { petto: [56, 60, 64, 68, 72] },
    '3006-VE': { petto: [60, 64, 68, 72, 76] },
    '3006-SET': { petto: [56, 60, 64, 68, 72], fianchi: [64, 68, 72, 76, 80] },
    '8022-CK': { vita: [50, 54, 58, 62], fianchi: [72, 77, 82, 87] },
    '8022-DK': { vita: [48, 52, 56, 60], fianchi: [70, 74, 78, 82] },
    '8022-BR': { petto: [64, 68, 72, 76] },
    '8022-VE': { vita: [58, 62, 66, 70], petto: [68, 73, 78, 83] },
    '8022-GZ': { petto: [68, 73, 78, 83] }
  };

  /* Misure di corpo attese per una donna di quella statura e quel peso.
     Servono SOLO come riferimento da cui misurare lo scostamento. */
  function expectedBody(h, w) {
    var dh = (h || 165) - 165;
    return {
      fianchi: 0.90 * w + 0.13 * dh + 46,
      vita:    0.80 * w + 0.10 * dh + 22,
      petto:   0.70 * w + 0.15 * dh + 50
    };
  }
  /* Quanti centimetri di corpo separano una taglia dalla successiva.
     Ricavati dal passo della matrice (circa 7,5 kg fra una fascia e
     l'altra) attraverso gli stessi coefficienti. */
  var BODY_STEP = { fianchi: 0.90 * 7.5, vita: 0.80 * 7.5, petto: 0.70 * 7.5 };

  /* Tabelle misure del capo, generate da gen-misure.py leggendo la
     sezione `size_table` del template — che e' la trascrizione delle
     尺码表 del fornitore. Non ribattute a mano: la Guida taglie e la
     sezione "Misure del capo" della pagina devono dire la stessa cosa.
     Misure a CAPO DISTESO, in centimetri. */
  var GARMENT_TABLE = {
    '3003-BD': { cols: ["Taglia", "Lunghezza cm", "Manica cm", "Petto cm", "Fianchi cm", "Fondo gamba cm"], rows: [["XS", "60", "68", "61", "64", "31"], ["S", "62", "69", "66", "69", "33"], ["M", "64", "70", "71", "74", "35"], ["L", "66", "71", "76", "79", "37"], ["XL", "68", "72", "81", "84", "39"]] },
    '3003-BR': { cols: ["Taglia", "Lunghezza cm", "Petto cm", "Fascia inferiore cm"], rows: [["XS", "14,5", "56", "50"], ["S", "15,5", "60", "54"], ["M", "16,5", "64", "56"], ["L", "17,5", "68", "60"], ["XL", "18,5", "72", "64"]] },
    '3003-CK': { cols: ["Taglia", "Lunghezza cm", "Vita cm", "Fianchi cm", "Fondo gamba cm", "Peso"], rows: [["XS", "80", "52", "66", "18", "215 g"], ["S", "82", "56", "70", "19", "233 g"], ["M", "84", "60", "74", "20", "252 g"], ["L", "86", "64", "78", "21", "274 g"], ["XL", "88", "68", "82", "22", "289 g"]] },
    '3003-DK': { cols: ["Taglia", "Lunghezza cm", "Vita cm", "Fianchi cm", "Fondo gamba cm"], rows: [["XS", "28", "52", "66", "34"], ["S", "29", "56", "70", "36"], ["M", "30", "60", "74", "38"], ["L", "31", "64", "78", "40"], ["XL", "32", "68", "82", "42"]] },
    '3003-GZ': { cols: ["Taglia", "Lunghezza cm", "Manica cm", "Petto cm", "Fondo cm"], rows: [["XS", "50", "61", "64", "70"], ["S", "51", "62", "68", "75"], ["M", "52", "63", "72", "80"], ["L", "53", "64", "76", "85"], ["XL", "54", "65", "80", "90"]] },
    '3003-MC': { cols: ["Taglia", "Lunghezza cm", "Manica cm", "Petto cm", "Fondo cm"], rows: [["XS", "45,5", "18", "63", "59"], ["S", "47", "19", "68", "64"], ["M", "48,5", "20", "72", "69"], ["L", "50", "21", "76", "74"], ["XL", "51,5", "22", "80", "79"]] },
    '3003-VE': { cols: ["Taglia", "Lunghezza cm", "Petto cm", "Fondo cm"], rows: [["XS", "36", "64", "56"], ["S", "37", "69", "60"], ["M", "38", "74", "64"], ["L", "39", "79", "68"], ["XL", "40", "84", "72"]] },
    '3003-ZA': { cols: ["Taglia", "Lunghezza cm", "Vita cm", "Fianchi cm", "Fondo gamba cm"], rows: [["XS", "91", "51", "65", "45"], ["S", "93", "56", "70", "47"], ["M", "95", "61", "75", "49"], ["L", "97", "66", "80", "51"], ["XL", "99", "71", "85", "53"]] },
    '8022-BR': { cols: ["Taglia", "Lunghezza cm", "Petto cm", "Vita cm"], rows: [["S", "43,5", "64", "60"], ["M", "45", "68", "64"], ["L", "46,5", "72", "68"], ["XL", "48", "76", "72"]] },
    '8022-CK': { cols: ["Taglia", "Lunghezza cm", "Vita cm", "Fianchi cm", "Fondo gamba cm"], rows: [["S", "80", "50", "72", "20"], ["M", "82", "54", "77", "22"], ["L", "84", "58", "82", "24"], ["XL", "86", "62", "87", "26"]] },
    '8022-DK': { cols: ["Taglia", "Lunghezza cm", "Vita cm", "Fianchi cm", "Fondo gamba cm"], rows: [["S", "33", "48", "70", "35"], ["M", "34", "52", "74", "37"], ["L", "35", "56", "78", "39"], ["XL", "36", "60", "82", "41"]] },
    '8022-GZ': { cols: ["Taglia", "Lunghezza cm", "Petto cm", "Manica cm", "Peso"], rows: [["S", "50", "68", "56,5", "217 g"], ["M", "52", "73", "57,5", "231 g"], ["L", "54", "78", "58,5", "254 g"], ["XL", "56", "83", "59,5", "262 g"]] },
    '8022-VE': { cols: ["Taglia", "Lunghezza cm", "Vita cm", "Petto cm"], rows: [["S", "41", "58", "68"], ["M", "42,5", "62", "73"], ["L", "44", "66", "78"], ["XL", "45,5", "70", "83"]] }
  };

  /* Le intestazioni del fornitore, tradotte. La chiave e' l'italiano perche'
     e' cosi' che stanno nel tema. */
  var MEASURE_LABEL = {
    'Taglia':              { en: 'Size', de: 'Größe', fr: 'Taille', es: 'Talla' },
    'Lunghezza cm':        { en: 'Length cm', de: 'Länge cm', fr: 'Longueur cm', es: 'Largo cm' },
    'Vita cm':             { en: 'Waist cm', de: 'Taille cm', fr: 'Tour de taille cm', es: 'Cintura cm' },
    'Fianchi cm':          { en: 'Hips cm', de: 'Hüfte cm', fr: 'Hanches cm', es: 'Cadera cm' },
    'Fondo gamba cm':      { en: 'Leg opening cm', de: 'Beinöffnung cm', fr: 'Bas de jambe cm', es: 'Bajo pierna cm' },
    'Petto cm':            { en: 'Bust cm', de: 'Brust cm', fr: 'Poitrine cm', es: 'Pecho cm' },
    'Manica cm':           { en: 'Sleeve cm', de: 'Ärmel cm', fr: 'Manche cm', es: 'Manga cm' },
    'Fondo cm':            { en: 'Hem cm', de: 'Saum cm', fr: 'Bas cm', es: 'Bajo cm' },
    'Fascia inferiore cm': { en: 'Underband cm', de: 'Unterbrustband cm', fr: 'Bande inférieure cm', es: 'Banda inferior cm' },
    'Peso':                { en: 'Weight', de: 'Gewicht', fr: 'Poids', es: 'Peso' }
  };


  /* ---------------------------------------------------------------------
     TAGLIA DALLE MISURE DEL CORPO
     E' la via diretta, e quando la cliente ci da' i centimetri e' quella che
     comanda: non passa da altezza e peso, quindi non eredita nessuna delle
     loro approssimazioni.

     Come si converte la misura del capo (a disteso) in quanto corpo ci sta
     dentro: si moltiplica per il fattore che riconcilia le DUE tabelle del
     fornitore fra loro — 1,27 su Seconda Pelle/Line, 1,21 su Costa. Non e'
     un numero scelto a occhio: e' quello che rende coerenti la griglia
     altezza/peso e la tabella misure, con dispersione 0,05 e 0,02.

     Regola: si prende la taglia piu' piccola che CONTIENE la misura. Se piu'
     misure sono state date, comanda quella che vincola di piu' — il capo
     deve passare dal punto piu' largo, non dalla media.
     --------------------------------------------------------------------- */
  var STRETCH = { '3003': 1.27, '3006': 1.27, '8022': 1.21 };
  var MEAS_COL = { vita: 'Vita cm', fianchi: 'Fianchi cm', petto: 'Petto cm' };

  function num(v) { return parseFloat(String(v).replace(',', '.')); }

  function sizeFromMeasures(ctx, meas) {
    var g = GARMENT_TABLE[ctx.gruppo], f = STRETCH[ctx.serie];
    if (!g || !f || !meas) return null;

    var scelte = [];
    Object.keys(MEAS_COL).forEach(function (k) {
      var v = meas[k];
      if (!(v > 0)) return;
      var ci = g.cols.indexOf(MEAS_COL[k]);
      if (ci < 0) return;

      var righe = g.rows.filter(function (r) { return ctx.available.indexOf(r[0]) > -1; });
      if (!righe.length) return;

      var presa = null, cap = 0, passo = 0;
      for (var i = 0; i < righe.length; i++) {
        var capacita = num(righe[i][ci]) * f;
        if (capacita >= v) {
          presa = righe[i][0];
          cap = capacita;
          var vicina = i > 0 ? righe[i - 1] : (righe[1] || righe[0]);
          passo = Math.abs(capacita - num(vicina[ci]) * f) || 5;
          break;
        }
      }
      if (!presa) {
        /* oltre la piu' grande: non esiste niente sopra, si da' quella */
        var ult = righe[righe.length - 1];
        presa = ult[0];
        cap = num(ult[ci]) * f;
        passo = righe.length > 1 ? Math.abs(cap - num(righe[righe.length - 2][ci]) * f) : 5;
      }
      scelte.push({ k: k, size: presa, v: v, cap: cap, passo: passo });
    });
    if (!scelte.length) return null;

    /* comanda la misura che chiede la taglia piu' grande */
    var vince = scelte[0];
    scelte.forEach(function (c) {
      if (CANON.indexOf(c.size) > CANON.indexOf(vince.size)) vince = c;
    });
    return { size: vince.size, da: vince, tutte: scelte };
  }

  var CANON = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  /* =====================================================================
     MOTORE
     ===================================================================== */

  function idxOfHeight(h) {
    if (h <= H_ROWS[0]) return 0;
    if (h >= H_ROWS[H_ROWS.length - 1]) return H_ROWS.length - 1;
    var best = 0, bestD = Infinity;
    for (var i = 0; i < H_ROWS.length; i++) {
      var d = Math.abs(H_ROWS[i] - h);
      if (d < bestD) { bestD = d; best = i; }
    }
    return best;
  }

  /* Lookup della matrice. Fra due colonne la scheda stessa dice di
     prendere la piu' grande, quindi si arrotonda verso l'alto. */
  function matrixLookup(serie, h, w) {
    var grid = MATRIX[serie];
    if (!grid) return null;
    var row = grid[idxOfHeight(h)];
    if (w > CEILING) return { size: null, over: true };
    if (w <= W_COLS[0]) return { size: row[0], col: 0, between: false, under: w < FLOOR };
    for (var i = 0; i < W_COLS.length; i++) {
      if (w === W_COLS[i]) return { size: row[i], col: i, between: false };
      if (w < W_COLS[i]) return { size: row[i], col: i, between: row[i] !== row[i - 1] };
    }
    return { size: row[row.length - 1], col: row.length - 1, between: false };
  }

  /* L'altezza fuori tabella: la v5 la schiacciava in silenzio sulla riga di
     bordo, quindi una donna di 185 cm riceveva la risposta dei 175 senza
     saperlo. Qui si guarda se l'estrapolazione conta davvero: se le due
     righe di bordo danno gia' la STESSA taglia a quel peso, il bordo e'
     piatto e proseguire non cambia niente. Se invece le due righe
     divergono siamo su un tratto in salita, e allora non si indovina.

     Restituisce true = fuori tabella, da dichiarare. */
  function heightOutOfChart(serie, h, col) {
    if (h < H_HARD_LO || h > H_HARD_HI) return true;
    if (h >= H_ROWS[0] && h <= H_ROWS[H_ROWS.length - 1]) return false;
    var grid = MATRIX[serie];
    if (!grid || col == null || col < 0) return true;
    var a, b;
    if (h < H_ROWS[0]) { a = grid[0][col]; b = grid[1][col]; }
    else { a = grid[grid.length - 1][col]; b = grid[grid.length - 2][col]; }
    return a !== b;
  }

  /* Estremi in kg della fascia occupata dalla taglia consigliata, sulla
     riga di altezza della cliente. Serve alla barra di vestibilita'. */
  /* Quali colonne della riga occupa la taglia consigliata. Serve alla barra
     di vestibilita'. */
  function bandFor(serie, h, size) {
    var row = MATRIX[serie][idxOfHeight(h)];
    var first = -1, last = -1;
    for (var i = 0; i < row.length; i++) {
      if (row[i] === size) { if (first < 0) first = i; last = i; }
    }
    if (first < 0) return null;
    return { first: first, last: last, cells: last - first + 1 };
  }

  function stepsBetween(a, b) { return CANON.indexOf(b) - CANON.indexOf(a); }

  function shiftSize(size, offset) {
    var i = CANON.indexOf(size);
    if (i < 0) return size;
    var steps = stepFromOffset(offset);
    return CANON[Math.max(0, Math.min(CANON.length - 1, i + steps))];
  }

  function largestOf(available) {
    for (var i = CANON.length - 1; i >= 0; i--) if (available.indexOf(CANON[i]) > -1) return CANON[i];
    return available[available.length - 1];
  }

  function clampToAvailable(size, available) {
    if (available.indexOf(size) > -1) return size;
    var ci = CANON.indexOf(size);
    for (var d = 1; d < CANON.length; d++) {
      if (ci + d < CANON.length && available.indexOf(CANON[ci + d]) > -1) return CANON[ci + d];
      if (ci - d >= 0 && available.indexOf(CANON[ci - d]) > -1) return CANON[ci - d];
    }
    return available[0] || size;
  }

  /* ---------------------------------------------------------------------
     recommend(): il calcolo completo.
     input = { h, w, bra, meas: { fianchi } }
     ctx   = { serie, gruppo, tipo, available }

     Esiti possibili, e sono tre e non uno:
       size       -> consiglio buono
       over/hOut  -> fuori dalla tabella: nessun consiglio, si dice
       unsure     -> i dati portano a due taglie: nessun consiglio, si dice
     --------------------------------------------------------------------- */
  /* I centimetri del capo per la taglia consigliata: numeri della tabella,
     senza nessuna stima dentro, e l'unica cosa che la cliente puo'
     verificare da sola con un metro. */
  function capoDellaTaglia(out, ctx, size) {
    var gm = GARMENT_MEASURES[ctx.gruppo];
    if (!gm) return;
    var gi = ctx.available.indexOf(size);
    out.capo = {};
    Object.keys(gm).forEach(function (zona) {
      if (gi > -1 && gm[zona][gi] != null) out.capo[zona] = gm[zona][gi];
    });
  }

  function recommend(input, ctx) {
    var out = {
      size: null, over: false, under: false, between: false, hOut: false,
      unsure: false, altSize: null, fallback: null,
      confidence: 0, signals: [], edge: null,
      gaugePct: 50, verdict: 'right', algo: ALGO
    };

    /* Se la cliente ha dato i centimetri, decidono loro: sono una misura
       del suo corpo, non una stima ricavata da altezza e peso. */
    var daMisure = sizeFromMeasures(ctx, input.meas);
    if (daMisure) {
      out.mode = 'misure';
      out.size = daMisure.size;
      out.baseSize = daMisure.size;
      out.misura = daMisure.da;
      out.confidence = 90;
      capoDellaTaglia(out, ctx, out.size);
      /* Quanto margine resta fra il corpo e il capo, dentro il passo di una
         taglia: tutto consumato = aderente, appena entrata = morbida. */
      var margine = (daMisure.da.cap - daMisure.da.v) / (daMisure.da.passo || 5);
      var stretta = Math.max(0, Math.min(1, 1 - margine));
      out.gaugePct = Math.round((1 - stretta) * 100);
      out.verdict = stretta < 0.3 ? 'roomy' : (stretta > 0.7 ? 'snug' : 'right');
      return out;
    }

    if (!(input.h > 0 && input.w > 0)) { out.unsupported = true; return out; }

    var base = matrixLookup(ctx.serie, input.h, input.w);
    if (!base) { out.unsupported = true; return out; }

    /* Fuori dalla tabella si consiglia comunque, in silenzio.
       Decisione del proprietario (13/08): al cliente non si espone il
       confine della tabella. Sopra l'ultima colonna si da' la taglia piu'
       grande del capo — che e' l'unica risposta possibile, visto che non
       ne esiste una sopra — senza spiegare perche'.
       I flag restano: non si vedono, ma viaggiano nel tracciamento, ed e'
       li' che si misura quanta domanda sta fuori dalla scala. */
    if (base.over) {
      /* Sopra l'ultima colonna si da' la piu' grande e NESSUN segnale la
         puo' ridurre: la cliente e' oltre il peso che la scheda copre, e
         tirarla giu' di una taglia su una misura stimata e' esattamente il
         modo di mandarle a casa un capo stretto. */
      out.over = true;
      out.size = largestOf(ctx.available);
      out.baseSize = out.size;
      out.confidence = 40;
      capoDellaTaglia(out, ctx, out.size);
      out.gaugePct = 50;
      out.verdict = 'right';
      return out;
    }

    var baseSize = base.size;
    out.between = !!base.between;
    out.under = !!base.under;
    out.baseSize = baseSize;
    out.hOut = heightOutOfChart(ctx.serie, input.h, base.col);

    var zone = GARMENT_ZONE[ctx.tipo] || 'full';
    var hardOffset = 0;
    var confidence = 55;   /* la sola matrice */
    var votes = [];        /* taglia proposta da ogni segnale indipendente */
    var anchor = null;     /* colonna pubblicata dalla scheda per QUESTO capo */

    /* --- reggiseno --- */
    if (input.bra && (zone === 'top' || zone === 'full')) {
      var mapped = (ctx.serie === '8022' && ctx.tipo === 'BR') ? bra8022(input.bra) : null;
      if (mapped === 'BEYOND') {
        mapped = largestOf(ctx.available);
        out.braBeyond = true;
      }
      if (mapped) {
        /* Colonna 罩杯 pubblicata per questo capo: comanda lei e diventa
           l'ANCORA, non una correzione della matrice. Su un reggiseno il
           petto batte il peso — ed e' un dato della scheda contro un altro
           dato della scheda, quindi non e' un disaccordo da segnalare. */
        anchor = mapped;
        confidence += 20;
        out.signals.push({ k: 'bra', v: input.bra, source: 'chart' });
      } else {
        var cupBias = CUP_BIAS[cupOf(input.bra)];
        if (cupBias != null) {
          hardOffset += cupBias;
          confidence += cupBias === 0 ? 0 : 12;
          votes.push(shiftSize(baseSize, cupBias * 1.01));
          out.signals.push({ k: 'bra', v: input.bra, delta: cupBias, source: 'cup' });
        }
      }
    }

    /* --- giro fianchi: il segnale piu' diretto che abbiamo ---
       Non si confronta in assoluto con la tabella del capo (misurata a
       disteso), ma con la misura ATTESA per la sua statura e il suo peso:
       cosi' si legge esattamente la cosa che la matrice non sa, cioe' di
       quanto quel corpo si discosta dalla media. E' un numero che la
       cliente ha misurato, quindi puo' spostare fino a due taglie. */
    var measShift = 0;   /* i centimetri li gestisce sizeFromMeasures, prima */

    /* --- risoluzione ---
       Con l'ancora si parte dalla colonna pubblicata per questo capo e la
       misura la corregge; senza ancora si parte dalla cella della matrice e
       si applica tutto lo scostamento accumulato. */
    var reference = anchor || baseSize;
    var raw = anchor ? shiftSize(anchor, measShift) : shiftSize(baseSize, hardOffset);

    var size = clampToAvailable(raw, ctx.available);
    out.rawSize = raw;
    out.offset = Math.round(hardOffset * 100) / 100;
    out.moved = stepsBetween(baseSize, size);

    /* --- quanto i segnali concordano ---
       Non decide piu' se rispondere (si risponde sempre): resta come
       misura interna, viaggia sull'ordine come _sf_conf ed e' li' che, sui
       resi, si vede quali consigli reggono. */
    votes.push(reference);
    var lo = 99, hi = -1;
    votes.forEach(function (v) {
      var i = CANON.indexOf(v);
      if (i < 0) return;
      if (i < lo) lo = i;
      if (i > hi) hi = i;
    });
    out.spread = hi > lo ? hi - lo : 0;
    confidence -= out.spread * 18;
    out.confidence = Math.max(20, Math.min(96, confidence));

    out.size = size;

    capoDellaTaglia(out, ctx, size);

    if (stepsBetween(raw, size) < 0) out.edge = 'top';
    else if (stepsBetween(raw, size) > 0) out.edge = 'low';

    /* --- barra di vestibilita': dove cade dentro la fascia ---
       `tight` = quanto sta in ALTO nella fascia di peso della sua taglia:
       piu' pesa dentro la stessa taglia, piu' il capo le sta aderente.
       La barra e' etichettata "aderente" a sinistra, quindi il pallino va
       posizionato all'inverso.

       Si prende il CENTRO della colonna in cui cade, non il suo estremo.
       Prima si misurava la posizione dentro l'intervallo continuo (lo, hi]:
       chi pesava esattamente quanto l'ultima colonna — cioe' quasi tutte,
       perche' i pesi si scrivono tondi e le colonne stanno di 2,5 in 2,5 —
       otteneva 1,0 esatto e il pallino finiva incollato al bordo della
       barra, che sembra un errore di disegno. La tabella e' fatta di
       colonne discrete: il posto giusto e' il mezzo della propria. */
    var band = bandFor(ctx.serie, input.h, size);
    if (band) {
      var pos = (base.col - band.first + 0.5) / band.cells;
      var tight = Math.max(0, Math.min(1, pos));
      out.gaugePct = Math.round((1 - tight) * 100);
      out.verdict = tight < 0.3 ? 'roomy' : (tight > 0.7 ? 'snug' : 'right');
    }

    return out;
  }

  /* =====================================================================
     TESTI — 5 lingue.
     Stanno qui e non nello snippet Liquid per un motivo pratico: l'API dei
     temi non accetta .liquid caricati da URL, mentre gli asset si'.

     Regola di copy: una frase per concetto, niente paragrafi. La taglia la
     consigliamo NOI e la fonte e' "la nostra tabella" — mai "il
     fornitore". Nessuna percentuale di affidabilita' a schermo.
     ===================================================================== */
  var I18N = {
    it: {
      title: 'Che taglia prendo?',
      fitnote: 'I nostri capi vestono una taglia sotto le taglie europee: nel calcolo è già compreso.',
      h: 'Altezza', w: 'Peso',
      measq: 'Le tue misure',
      meashint: 'Metro aderente, non stretto. I fianchi nel punto più largo, la vita nel punto più stretto.',
      m_vita: 'Vita',
      m_fianchi: 'Fianchi',
      m_petto: 'Petto',
      oppure: 'oppure, se non hai un metro',
      bra: 'Taglia di reggiseno',
      bra_hint: 'Come sull’etichetta, per esempio 75B.',
      band: 'Fascia', cup: 'Coppa',
      cta: 'Vedi la mia taglia',
      err: 'Inserisci altezza e peso.',
      guide_note: 'Misure del capo a disteso, tolleranza 1-3 cm. Non sono misure del corpo: la maglia è elastica e si adatta.',
      edit: 'Modifica i dati',
      close: 'Chiudi',
      reco: 'La tua taglia è',
      g_left: 'aderente', g_right: 'morbida',
      verdict_snug: 'Ti starà aderente',
      verdict_right: 'Ti starà giusta',
      verdict_roomy: 'Ti starà morbida',
      capo_label: 'La {s}, a capo disteso:',
      capo_vita: 'vita', capo_fianchi: 'fianchi', capo_petto: 'petto',
      why_largest: 'La {s} è la taglia più grande di questo capo.',
      why_chart: 'Per altezza e peso, sulla nostra tabella sei una {s}.',
      why_meas: 'Con {v} cm di {m} entri nella {s}.',
      why_bra: 'Su questo capo decide il petto: con la {v} sei una {s}.',
      n_between: 'Sei fra due taglie e ti diamo la più grande: sul seamless è quella che si adatta.',
      n_under: 'La {s} è la più piccola di questo capo ed è la tua.',
      n_top: 'La {s} è la più grande di questo capo, e ci rientri.',
      apply: 'Scegli la {s}',
      soldout: 'Questa taglia è esaurita al momento.',
      privacy: 'I dati restano sul tuo dispositivo. All’ordine alleghiamo solo la taglia consigliata.'
    },
    en: {
      title: 'Which size do I take?',
      fitnote: 'Our pieces run one size below European sizing. The calculation already includes that.',
      h: 'Height', w: 'Weight',
      measq: 'Your measurements',
      meashint: 'Tape snug, not tight. Hips at the fullest part, waist at the narrowest.',
      m_vita: 'Waist',
      m_fianchi: 'Hips',
      m_petto: 'Bust',
      oppure: 'or, if you have no tape measure',
      bra: 'Bra size',
      bra_hint: 'As on the label, for example 75B (34B).',
      band: 'Band', cup: 'Cup',
      cta: 'See my size',
      err: 'Enter height and weight.',
      guide_note: 'Garment measured flat, tolerance 1-3 cm. These are not body measurements: the knit is elastic and adapts.',
      edit: 'Edit my details',
      close: 'Close',
      reco: 'Your size is',
      g_left: 'close-fitting', g_right: 'soft',
      verdict_snug: 'It will sit close',
      verdict_right: 'It will sit right',
      verdict_roomy: 'It will sit soft',
      capo_label: 'Size {s}, laid flat:',
      capo_vita: 'waist', capo_fianchi: 'hips', capo_petto: 'bust',
      why_largest: '{s} is the largest size of this piece.',
      why_chart: 'By height and weight, on our chart you are a {s}.',
      why_meas: 'At {v} cm of {m} you fall inside {s}.',
      why_bra: 'On this piece the bust decides: with a {v} you are a {s}.',
      n_between: 'You sit between two sizes and we give you the larger one: on seamless that is the one that adapts.',
      n_under: '{s} is the smallest size of this piece, and it is yours.',
      n_top: '{s} is the largest size of this piece, and you fit inside it.',
      apply: 'Choose {s}',
      soldout: 'That size is sold out right now.',
      privacy: 'Your data stays on your device. Only the recommended size is attached to the order.'
    },
    de: {
      title: 'Welche Größe nehme ich?',
      fitnote: 'Unsere Teile fallen eine Größe kleiner aus als europäische Größen. Die Berechnung berücksichtigt das bereits.',
      h: 'Körpergröße', w: 'Gewicht',
      measq: 'Deine Maße',
      meashint: 'Maßband anliegend, nicht straff. Hüfte an der breitesten, Taille an der schmalsten Stelle.',
      m_vita: 'Taille',
      m_fianchi: 'Hüfte',
      m_petto: 'Brust',
      oppure: 'oder, wenn du kein Maßband hast',
      bra: 'BH-Größe',
      bra_hint: 'Wie auf dem Etikett, zum Beispiel 75B.',
      band: 'Unterbrust', cup: 'Cup',
      cta: 'Meine Größe zeigen',
      err: 'Bitte Körpergröße und Gewicht eingeben.',
      guide_note: 'Teil flach gemessen, Toleranz 1-3 cm. Das sind keine Körpermaße: das Gestrick ist elastisch und passt sich an.',
      edit: 'Angaben ändern',
      close: 'Schließen',
      reco: 'Deine Größe ist',
      g_left: 'eng', g_right: 'weich',
      verdict_snug: 'Sitzt eng an',
      verdict_right: 'Sitzt genau',
      verdict_roomy: 'Sitzt weich',
      capo_label: 'Größe {s}, flach gemessen:',
      capo_vita: 'Taille', capo_fianchi: 'Hüfte', capo_petto: 'Brust',
      why_largest: '{s} ist die größte Größe dieses Teils.',
      why_chart: 'Nach Größe und Gewicht bist du auf unserer Tabelle eine {s}.',
      why_meas: 'Mit {v} cm {m} liegst du in {s}.',
      why_bra: 'Bei diesem Teil entscheidet die Brust: mit {v} bist du eine {s}.',
      n_between: 'Du liegst zwischen zwei Größen und bekommst die größere: bei Seamless passt sich diese an.',
      n_under: '{s} ist die kleinste Größe dieses Teils, und sie ist deine.',
      n_top: '{s} ist die größte Größe dieses Teils, und deine Maße liegen darin.',
      apply: '{s} wählen',
      soldout: 'Diese Größe ist derzeit ausverkauft.',
      privacy: 'Deine Daten bleiben auf deinem Gerät. An die Bestellung hängen wir nur die empfohlene Größe.'
    },
    fr: {
      title: 'Quelle taille je prends ?',
      fitnote: 'Nos pièces taillent une taille en dessous des tailles européennes. Le calcul en tient déjà compte.',
      h: 'Taille', w: 'Poids',
      measq: 'Vos mesures',
      meashint: 'Mètre ajusté, pas serré. Les hanches à l’endroit le plus large, la taille au plus étroit.',
      m_vita: 'Tour de taille',
      m_fianchi: 'Hanches',
      m_petto: 'Poitrine',
      oppure: 'ou, si vous n’avez pas de mètre',
      bra: 'Taille de soutien-gorge',
      bra_hint: 'Comme sur l’étiquette, par exemple 90B (75B).',
      band: 'Tour', cup: 'Bonnet',
      cta: 'Voir ma taille',
      err: 'Indiquez taille et poids.',
      guide_note: 'Pièce mesurée à plat, tolérance 1-3 cm. Ce ne sont pas des mesures du corps : la maille est élastique et s’adapte.',
      edit: 'Modifier mes données',
      close: 'Fermer',
      reco: 'Votre taille est',
      g_left: 'ajusté', g_right: 'souple',
      verdict_snug: 'Elle sera ajustée',
      verdict_right: 'Elle sera juste',
      verdict_roomy: 'Elle sera souple',
      capo_label: 'La {s}, à plat :',
      capo_vita: 'taille', capo_fianchi: 'hanches', capo_petto: 'poitrine',
      why_largest: 'La {s} est la plus grande taille de cette pièce.',
      why_chart: 'Selon la taille et le poids, sur notre tableau vous êtes une {s}.',
      why_meas: 'Avec {v} cm de {m} vous entrez dans la {s}.',
      why_bra: 'Sur cette pièce c’est la poitrine qui décide : avec un {v} vous êtes une {s}.',
      n_between: 'Vous êtes entre deux tailles et nous donnons la plus grande : sur le seamless c’est celle qui s’adapte.',
      n_under: 'La {s} est la plus petite taille de cette pièce, et c’est la vôtre.',
      n_top: 'La {s} est la plus grande taille de cette pièce, et vous y rentrez.',
      apply: 'Choisir la {s}',
      soldout: 'Cette taille est épuisée pour le moment.',
      privacy: 'Vos données restent sur votre appareil. Seule la taille conseillée est jointe à la commande.'
    },
    es: {
      title: '¿Qué talla me llevo?',
      fitnote: 'Nuestras prendas tallan una talla menos que las tallas europeas. El cálculo ya lo tiene en cuenta.',
      h: 'Altura', w: 'Peso',
      measq: 'Tus medidas',
      meashint: 'Cinta ajustada, no apretada. La cadera por la parte más ancha, la cintura por la más estrecha.',
      m_vita: 'Cintura',
      m_fianchi: 'Cadera',
      m_petto: 'Pecho',
      oppure: 'o, si no tienes cinta métrica',
      bra: 'Talla de sujetador',
      bra_hint: 'Como en la etiqueta, por ejemplo 85B (75B).',
      band: 'Contorno', cup: 'Copa',
      cta: 'Ver mi talla',
      err: 'Introduce altura y peso.',
      guide_note: 'Prenda medida en plano, tolerancia 1-3 cm. No son medidas del cuerpo: el tejido es elástico y se adapta.',
      edit: 'Cambiar mis datos',
      close: 'Cerrar',
      reco: 'Tu talla es',
      g_left: 'ceñida', g_right: 'suelta',
      verdict_snug: 'Te quedará ceñida',
      verdict_right: 'Te quedará justa',
      verdict_roomy: 'Te quedará suelta',
      capo_label: 'La {s}, en plano:',
      capo_vita: 'cintura', capo_fianchi: 'cadera', capo_petto: 'pecho',
      why_largest: 'La {s} es la talla más grande de esta prenda.',
      why_chart: 'Por altura y peso, en nuestra tabla eres una {s}.',
      why_meas: 'Con {v} cm de {m} entras en la {s}.',
      why_bra: 'En esta prenda manda el pecho: con una {v} eres una {s}.',
      n_between: 'Estás entre dos tallas y te damos la más grande: en el seamless es la que se adapta.',
      n_under: 'La {s} es la talla más pequeña de esta prenda, y es la tuya.',
      n_top: 'La {s} es la talla más grande de esta prenda, y entras.',
      apply: 'Elegir la {s}',
      soldout: 'Esa talla está agotada ahora mismo.',
      privacy: 'Tus datos se quedan en tu dispositivo. Al pedido solo adjuntamos la talla recomendada.'
    }
  };

  /* Figura per il giro fianchi. Esiste per una ragione sola: "fianchi" e'
     una parola ambigua — molte clienti misurano il punto vita o il giro
     dei trocanteri. La fettuccia disegnata nel punto giusto toglie
     l'ambiguita' meglio di qualsiasi frase. */
  /* Geometria verificata a schermo: la vita si stringe a 20 unita' e i
     fianchi si aprono a 38, cosi' il punto piu' largo si legge anche a 66
     px di larghezza. La fettuccia sta esattamente li' e deborda di 5 unita'
     per lato: piu' corta si confonde col corpo, piu' lunga sembra un
     oggetto staccato. */
  var HIPS_SVG =
    '<svg class="rsa-fig" viewBox="0 0 80 112" aria-hidden="true">' +
      '<circle class="rsa-fig__body" cx="40" cy="12" r="7"/>' +
      '<path class="rsa-fig__body" d="M40 24 Q27 26 27 34 Q25 45 30 53 Q21 60 21 70 Q21 80 25 87 L55 87 Q59 80 59 70 Q59 60 50 53 Q55 45 53 34 Q53 26 40 24 Z"/>' +
      '<rect class="rsa-fig__body" x="27" y="85" width="10" height="24" rx="5"/>' +
      '<rect class="rsa-fig__body" x="43" y="85" width="10" height="24" rx="5"/>' +
      '<line class="rsa-fig__tape" x1="16" y1="70" x2="64" y2="70"/>' +
      '<line class="rsa-fig__cap" x1="16" y1="63" x2="16" y2="77"/>' +
      '<line class="rsa-fig__cap" x1="64" y1="63" x2="64" y2="77"/>' +
    '</svg>';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Costruisce la modale. Un solo overlay per pagina, agganciato al body
     per uscire dal form e dagli stacking context del tema.

     Il form si compone dal tipo di capo e non chiede MAI un dato che il
     motore poi non legge: e' la regola che questa versione introduce. */
  function buildModal(T, zone) {
    var existing = document.querySelector('[data-rsa-overlay]');
    if (existing) return existing;

    var braHtml = (zone === 'top' || zone === 'full') ?
      '<div class="rsa-block">' +
        '<div class="rsa-block__q">' + esc(T.bra) + '</div>' +
        '<div class="rsa-block__hint">' + esc(T.bra_hint) + '</div>' +
        '<div class="rsa-fields">' +
          '<label class="rsa-field"><span>' + esc(T.band) + '</span><select data-rsa-braband><option value="">—</option></select></label>' +
          '<label class="rsa-field"><span>' + esc(T.cup) + '</span><select data-rsa-bracup><option value="">—</option></select></label>' +
        '</div>' +
      '</div>' : '';

    /* Le MISURE per prime: sono la via diretta e la sola che la cliente puo'
       controllare da sola con un metro. Altezza e peso restano sotto, per chi
       il metro non ce l'ha in mano. */
    var campiMisura = zone === 'top'
      ? [['petto', T.m_petto], ['vita', T.m_vita]]
      : (zone === 'full'
          ? [['petto', T.m_petto], ['vita', T.m_vita], ['fianchi', T.m_fianchi]]
          : [['vita', T.m_vita], ['fianchi', T.m_fianchi]]);

    var misureHtml =
      '<div class="rsa-block">' +
        '<div class="rsa-block__q">' + esc(T.measq) + '</div>' +
        '<div class="rsa-measure">' +
          HIPS_SVG +
          '<div class="rsa-measure__side">' +
            '<div class="rsa-block__hint">' + esc(T.meashint) + '</div>' +
            '<div class="rsa-fields">' +
              campiMisura.map(function (c) {
                return '<label class="rsa-field rsa-field--unit"><span>' + esc(c[1]) + '</span>' +
                  '<input type="number" inputmode="numeric" min="40" max="180" step="1" data-rsa-' + c[0] +
                  ' placeholder="—" enterkeyhint="go"><i>cm</i></label>';
              }).join('') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    var o = document.createElement('div');
    o.className = 'rsa-overlay';
    o.setAttribute('data-rsa-overlay', '');
    o.hidden = true;
    o.innerHTML =
      '<div class="rsa-modal" role="dialog" aria-modal="true" aria-label="' + esc(T.title) + '">' +
        '<button type="button" class="rsa-close" data-rsa-close aria-label="' + esc(T.close) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M18 6L6 18M6 6l12 12" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '</button>' +

        '<h2 class="rsa-title">' + esc(T.title) + '</h2>' +
        '<p class="rsa-fitnote">' + esc(T.fitnote) + '</p>' +

        '<div class="rsa-form" data-rsa-form>' +
          misureHtml +
          '<div class="rsa-or">' + esc(T.oppure) + '</div>' +
          '<div class="rsa-fields">' +
            '<label class="rsa-field rsa-field--unit"><span>' + esc(T.h) + '</span>' +
              '<input type="number" inputmode="numeric" min="130" max="210" step="1" data-rsa-h placeholder="168" enterkeyhint="go"><i>cm</i></label>' +
            '<label class="rsa-field rsa-field--unit"><span>' + esc(T.w) + '</span>' +
              '<input type="number" inputmode="decimal" min="30" max="200" step="1" data-rsa-w placeholder="62" enterkeyhint="go"><i>kg</i></label>' +
          '</div>' +
          braHtml +
          '<div class="rsa-err" data-rsa-err hidden>' + esc(T.err) + '</div>' +
          '<button type="button" class="rsa-btn" data-rsa-calc>' + esc(T.cta) + '</button>' +
        '</div>' +

        /* SCHERMATA 2. Prende il posto del form invece di accodarsi sotto.
           Prima il risultato compariva in fondo a una modale alta 92vh: su
           un telefono nasceva sotto il bordo, quindi si premeva "Vedi la
           mia taglia" e non si vedeva succedere niente. Il calcolo era
           giusto e invisibile, che e' come non averlo fatto. */
        '<div class="rsa-result" data-rsa-result hidden>' +
          '<div class="rsa-result__head" data-rsa-head>' +
            '<span>' + esc(T.reco) + '</span> <b class="rsa__chip rsa__chip--big" data-rsa-size></b>' +
          '</div>' +
          '<div class="rsa-gauge" data-rsa-gauge>' +
            '<div class="rsa-gauge__track"><span class="rsa-gauge__dot" data-rsa-dot style="left:50%"></span></div>' +
            '<div class="rsa-gauge__ends"><span>' + esc(T.g_left) + '</span><span>' + esc(T.g_right) + '</span></div>' +
            '<div class="rsa-gauge__verdict" data-rsa-verdict></div>' +
          '</div>' +
          /* I centimetri veri della taglia consigliata, presi dalla tabella:
             l'unico numero del riquadro che la cliente puo' verificare da
             sola con un metro. */
          '<div class="rsa-capo" data-rsa-capo hidden></div>' +
          '<p class="rsa-why" data-rsa-why hidden></p>' +
          '<div class="rsa-stop" data-rsa-stop hidden></div>' +
          '<button type="button" class="rsa-apply" data-rsa-apply hidden></button>' +
          '<button type="button" class="rsa-edit" data-rsa-edit>' + esc(T.edit) + '</button>' +
        '</div>' +

        '<div class="rsa-privacy">' + esc(T.privacy) + '</div>' +
      '</div>';
    document.body.appendChild(o);
    return o;
  }

  /* =====================================================================
     UI
     ===================================================================== */

  function init(root) {
    if (!root || root.__rsaInit) return;
    root.__rsaInit = true;

    var cfgEl = root.querySelector('[data-rsa-config]');
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!CFG.serie || !MATRIX[CFG.serie] || !CFG.sizes || !CFG.sizes.length) return;

    var T = I18N[CFG.lang] || I18N.it;
    var ctx = { serie: CFG.serie, gruppo: CFG.gruppo, tipo: CFG.tipo, available: CFG.sizes };
    var zone = GARMENT_ZONE[ctx.tipo] || 'full';

    var overlay = buildModal(T, zone);
    var q = function (s) { return overlay.querySelector(s); };
    var qa = function (s, scope) { return Array.prototype.slice.call((scope || overlay).querySelectorAll(s)); };

    var el = {
      open: root.querySelector('[data-rsa-open]'),
      cta: root.querySelector('[data-rsa-cta]'),
      have: root.querySelector('[data-rsa-have]'),
      chip: root.querySelector('[data-rsa-chip]'),
      close: q('[data-rsa-close]'),
      h: q('[data-rsa-h]'),
      w: q('[data-rsa-w]'),
      braBand: q('[data-rsa-braband]'),
      braCup: q('[data-rsa-bracup]'),
      form: q('[data-rsa-form]'),
      err: q('[data-rsa-err]'),
      calc: q('[data-rsa-calc]'),
      result: q('[data-rsa-result]'),
      head: q('[data-rsa-head]'),
      size: q('[data-rsa-size]'),
      gauge: q('[data-rsa-gauge]'),
      dot: q('[data-rsa-dot]'),
      verdict: q('[data-rsa-verdict]'),
      capo: q('[data-rsa-capo]'),
      why: q('[data-rsa-why]'),
      stop: q('[data-rsa-stop]'),
      apply: q('[data-rsa-apply]'),
      edit: q('[data-rsa-edit]')
    };

    if (el.braBand) {
      BRA_BANDS.forEach(function (b) {
        var o = document.createElement('option'); o.value = b; o.textContent = b;
        el.braBand.appendChild(o);
      });
      BRA_CUPS.forEach(function (c) {
        var o = document.createElement('option'); o.value = c; o.textContent = c;
        el.braCup.appendChild(o);
      });
    }

    function num(node) {
      var v = node && parseFloat(String(node.value).replace(',', '.'));
      return v > 0 ? v : null;
    }

    function readInput() {
      var band = el.braBand && el.braBand.value;
      var cup = el.braCup && el.braCup.value;
      return {
        h: parseInt(el.h.value, 10),
        w: num(el.w),
        bra: (band && cup) ? (band + cup) : '',
        meas: {
          vita:    num(overlay.querySelector('[data-rsa-vita]')),
          fianchi: num(overlay.querySelector('[data-rsa-fianchi]')),
          petto:   num(overlay.querySelector('[data-rsa-petto]'))
        }
      };
    }

    /* ---- profilo ---- */
    function loadProfile() {
      try {
        var p = JSON.parse(localStorage.getItem(KEY));
        if (p && (p.h || (p.meas && (p.meas.vita || p.meas.fianchi || p.meas.petto)))) return p;
      } catch (e) {}
      for (var i = 0; i < LEGACY_KEYS.length; i++) {
        try {
          var old = JSON.parse(localStorage.getItem(LEGACY_KEYS[i]));
          /* del profilo vecchio si tengono solo i campi che questa versione
             usa ancora: altezza, peso, reggiseno, fianchi. Brand, forma e
             vestibilita' non esistono piu' e non vanno resuscitati. */
          if (old && old.h && old.w) {
            return {
              h: old.h, w: old.w, bra: old.bra || '',
              meas: { fianchi: (old.meas && old.meas.fianchi) || null },
              migrated: true
            };
          }
        } catch (e) {}
      }
      return null;
    }
    function saveProfile(p) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} }

    /* ---- tracking ---- */
    function band5(v) { if (!(v > 0)) return ''; var lo = Math.floor(v / 5) * 5; return lo + '-' + (lo + 4); }

    function track(action, extra) {
      var p = loadProfile();
      var payload = {
        event: 'rlv_size_advisor', sf_action: action, sf_algo: ALGO,
        sf_serie: ctx.serie, sf_gruppo: ctx.gruppo, sf_zone: zone
      };
      if (p) {
        payload.sf_reco = p.reco;
        payload.sf_hband = band5(p.h);
        payload.sf_wband = band5(p.w);
        payload.sf_bracup = p.bra ? p.bra.replace(/[0-9]/g, '') : '';
        payload.sf_hips = (p.meas && p.meas.fianchi) ? band5(p.meas.fianchi) : '';
        payload.sf_conf = p.conf;
      }
      if (extra) for (var k in extra) payload[k] = extra[k];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      try {
        if (window.clarity) {
          if (action === 'reco') {
            window.clarity('set', 'sf_reco', String(payload.sf_reco));
            window.clarity('event', 'size_advisor_used');
          }
          /* I tre modi in cui il widget si rifiuta di rispondere sono la
             cosa piu' interessante da misurare: dicono quanta domanda sta
             fuori dalla tabella. */
          if (action.indexOf('stop_') === 0) {
            window.clarity('set', 'sf_stop', action);
            window.clarity('event', 'size_advisor_no_answer');
          }
          if (action === 'mismatch') {
            window.clarity('set', 'sf_mismatch', payload.sf_chosen + '!=' + payload.sf_reco);
          }
        }
      } catch (e) {}
    }

    /* ---- line item properties: il consiglio viaggia sull'ordine ----
       Sull'ordine nominativo mandiamo solo le FASCE (5 cm / 5 kg), mai
       altezza, peso e misure esatte: bastano a ricalibrare la matrice e non
       trasformano un ordine in una scheda antropometrica. */
    function injectProps() {
      var p = loadProfile();
      if (!p || !p.reco) return;
      var fields = {
        _sf_reco: p.reco,
        _sf_hband: band5(p.h),
        _sf_wband: band5(p.w),
        _sf_bra: p.bra ? p.bra.replace(/[0-9]/g, '') : '',
        _sf_hips: (p.meas && p.meas.fianchi) ? band5(p.meas.fianchi) : '',
        _sf_conf: String(p.conf || ''),
        _sf_grid: ctx.serie + '-' + (ctx.tipo || ''),
        _sf_algo: ALGO
      };
      qa('form[action*="/cart/add"]', document).forEach(function (form) {
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        if (!idInput || !(idInput.value in CFG.vmap)) return;
        for (var name in fields) {
          var input = form.querySelector('input[name="properties[' + name + ']"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[' + name + ']';
            form.appendChild(input);
          }
          input.value = fields[name];
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[name="add"], .atc-button, [data-skip-cart-button]');
      if (!btn) return;
      injectProps();
      var p = loadProfile();
      if (!p || !p.reco) return;
      var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"], select[name="id"]');
      var chosen = idInput && CFG.vmap[idInput.value];
      if (!chosen) return;
      track(chosen === p.reco ? 'match' : 'mismatch', { sf_chosen: chosen });
    }, true);

    /* ---- rendering ---- */
    function fill(t, extra) {
      t = String(t || '')
        .replace(/\{kg\}/g, String(CEILING).replace('.', ','))
        .replace(/\{serie\}/g, CFG.serieLabel || ctx.serie);
      if (extra) Object.keys(extra).forEach(function (k) {
        t = t.replace(new RegExp('\\{' + k + '\\}', 'g'), extra[k]);
      });
      return t;
    }

    /* Le tre uscite senza taglia hanno tutte la stessa forma: una frase che
       dice perche' non rispondiamo, il contatto diretto, e — quando ha un
       senso — il bottone per scegliere comunque. Mai una taglia stampata
       grande con accanto un'avvertenza. */
    /* Le due schermate. Il form NON resta sopra il risultato: viene
       sostituito. Su un telefono, con la modale a 92vh, il riquadro del
       risultato nasceva sotto il bordo e sembrava che il bottone non
       facesse niente. */
    function mostraForm() {
      el.result.hidden = true;
      el.form.hidden = false;
      try { overlay.querySelector('.rsa-modal').scrollTop = 0; } catch (e) {}
    }

    function showResult(r) {
      el.form.hidden = true;
      el.result.hidden = false;
      el.stop.hidden = true;
      try { overlay.querySelector('.rsa-modal').scrollTop = 0; } catch (e) {}

      el.head.hidden = false;
      el.gauge.hidden = false;
      el.apply.hidden = false;
      el.size.textContent = r.size;

      el.dot.style.left = Math.max(4, Math.min(96, r.gaugePct)) + '%';
      el.verdict.textContent = T['verdict_' + r.verdict] || '';

      /* I centimetri della taglia consigliata, dalla tabella. */
      if (r.capo && Object.keys(r.capo).length) {
        var parti = Object.keys(r.capo).map(function (z) {
          return esc(T['capo_' + z] || z) + ' <b>' + r.capo[z] + ' cm</b>';
        });
        el.capo.innerHTML = '<span>' + esc(fill(T.capo_label, { s: r.size })) + '</span> ' + parti.join(' · ');
        el.capo.hidden = false;
      } else {
        el.capo.hidden = true;
      }

      /* UNA riga di spiegazione, quella del segnale che ha deciso davvero.
         Prima erano fino a cinque, e ognuna descriveva un input invece del
         suo effetto: il riquadro poteva dire "una taglia sopra la tabella"
         sopra un consiglio che era esattamente quello della tabella. */
      /* Sopra l'ultima colonna la tabella non arriva: dire "sulla nostra
         tabella sei una XL" sarebbe falso. Si dice il fatto, che e' vero e
         non espone nessun limite. */
      var why;
      if (r.over) why = fill(T.why_largest, { s: r.size });
      else if (r.mode === 'misure') {
        why = fill(T.why_meas, { v: r.misura.v, m: (T['m_' + r.misura.k] || r.misura.k).toLowerCase(), s: r.size });
      } else why = fill(T.why_chart, { s: r.size });
      var braSig = null, measSig = null;
      r.signals.forEach(function (s) {
        if (s.k === 'bra') braSig = s;
        if (s.k === 'meas') measSig = s;
      });
      if (braSig && braSig.source === 'chart') why = fill(T.why_bra, { v: braSig.v, s: r.size });
      else if (measSig && r.moved !== 0) why = fill(T.why_meas, { v: measSig.v, s: r.size });
      else if (braSig && r.moved !== 0) why = fill(T.why_bra, { v: braSig.v, s: r.size });

      /* Al massimo una nota, e solo se dice qualcosa che il resto del
         riquadro non dice gia'. */
      var note = '';
      if (r.under) note = fill(T.n_under, { s: r.size });
      else if (r.edge === 'top') note = fill(T.n_top, { s: r.size });
      else if (r.between && (r.moved || 0) >= 0) note = fill(T.n_between);

      el.why.textContent = note ? (why + ' ' + note) : why;
      el.why.hidden = false;

      el.apply.textContent = fill(T.apply, { s: r.size });
      el.apply.setAttribute('data-size', r.size);
    }

    function compute(persist) {
      var inp = readInput();
      var haMisure = inp.meas && (inp.meas.vita > 0 || inp.meas.fianchi > 0 || inp.meas.petto > 0);
      var haHW = inp.h >= 130 && inp.h <= 210 && inp.w >= 30 && inp.w <= 200;
      if (!haMisure && !haHW) {
        el.err.hidden = false;
        mostraForm();
        /* Si torna al form con l'errore in vista: mai lasciare una
           schermata vuota. */
        return null;
      }
      el.err.hidden = true;
      var r = recommend(inp, ctx);
      if (persist) {
        saveProfile({
          h: inp.h, w: inp.w, bra: inp.bra, meas: inp.meas,
          reco: r.size || '', conf: r.confidence, algo: ALGO, ts: Date.now()
        });
      }
      showResult(r);
      paintBar();
      if (r.size) track('reco', { sf_offset: r.offset, sf_base: r.baseSize });
      return r;
    }

    function paintBar() {
      var p = loadProfile();
      var reco = '';
      if (p) {
        /* il profilo si ricalcola su QUESTO capo: la stessa cliente puo'
           essere M sulla 3003 e L sulla 8022, ed e' corretto cosi'. */
        var r = recommend({ h: p.h, w: p.w, bra: p.bra, meas: p.meas }, ctx);
        reco = r.size || '';
        if (p.reco !== reco || p.algo !== ALGO) {
          p.reco = reco; p.conf = r.confidence; p.algo = ALGO; saveProfile(p);
        }
      }
      /* Senza una taglia si torna alla chiamata all'azione: la barra non
         deve mai mostrare una pastiglia vuota. */
      if (reco) {
        el.chip.textContent = reco;
        el.cta.hidden = true; el.have.hidden = false;
      } else {
        el.cta.hidden = false; el.have.hidden = true;
      }
      injectProps();
    }

    function fillFromProfile() {
      var p = loadProfile();
      if (!p) { mostraForm(); return; }
      if (p.h) el.h.value = p.h;
      if (p.w) el.w.value = p.w;
      ['vita', 'fianchi', 'petto'].forEach(function (k) {
        var n = overlay.querySelector('[data-rsa-' + k + ']');
        if (n && p.meas && p.meas[k]) n.value = p.meas[k];
      });
      if (p.bra && el.braBand) {
        el.braBand.value = p.bra.replace(/[A-Z]/g, '');
        el.braCup.value = p.bra.replace(/[0-9]/g, '');
      }
      showResult(recommend({ h: p.h, w: p.w, bra: p.bra, meas: p.meas }, ctx));
    }

    /* ---- eventi ---- */
    function openModal() { fillFromProfile(); overlay.hidden = false; document.body.style.overflow = 'hidden'; track('open'); }
    function closeModal() { overlay.hidden = true; document.body.style.overflow = ''; }

    el.open.addEventListener('click', openModal);
    el.close.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeModal(); });

    el.calc.addEventListener('click', function () { compute(true); });
    el.edit.addEventListener('click', mostraForm);

    /* Niente ricalcolo dal vivo: con due schermate il form e il risultato
       non sono mai a schermo insieme, quindi non c'e' nulla da aggiornare
       mentre si scrive. Si corregge, si ripreme il bottone. Resta l'Invio
       come scorciatoia. */
    qa('input, select').forEach(function (n) {
      n.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); el.calc.click(); }
      });
    });

    /* Seleziona la taglia nel selettore del prodotto e restituisce
       l'elemento VISIBILE che la rappresenta (la pastiglia, non il radio
       nascosto), perche' serve poi per portarci sopra la vista.

       Tre rotte, in ordine: il radio nascosto dietro l'etichetta (com'e'
       fatto il tema oggi), il menu a tendina, il bottone col testo della
       taglia. Il tema puo' cambiare aspetto senza che questo si rompa. */
    function selectSize(size) {
      if (ctx.available.indexOf(size) === -1) return null;

      var radios = document.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        if (r.value !== size || r.disabled) continue;
        r.click();
        if (!r.checked) continue;
        /* alcuni temi ascoltano input, non solo change */
        ['input', 'change'].forEach(function (ev) {
          r.dispatchEvent(new Event(ev, { bubbles: true }));
        });
        return (r.id && document.querySelector('label[for="' + r.id + '"]')) ||
               r.nextElementSibling || r.parentElement;
      }

      var sels = document.querySelectorAll('select[name^="options"], select[name="id"]');
      for (var s = 0; s < sels.length; s++) {
        var opts = sels[s].options;
        for (var o = 0; o < opts.length; o++) {
          if (opts[o].value !== size && opts[o].textContent.trim() !== size) continue;
          if (opts[o].disabled) continue;
          sels[s].value = opts[o].value;
          ['input', 'change'].forEach(function (ev) {
            sels[s].dispatchEvent(new Event(ev, { bubbles: true }));
          });
          return sels[s];
        }
      }

      var nodi = document.querySelectorAll('button, label, a[data-value]');
      for (var b = 0; b < nodi.length; b++) {
        if (nodi[b].textContent.trim() !== size) continue;
        if (nodi[b].disabled || nodi[b].closest('[data-rsa-overlay]')) continue;
        nodi[b].click();
        return nodi[b];
      }
      return null;
    }

    el.apply.addEventListener('click', function () {
      var size = el.apply.getAttribute('data-size');
      var nodo = selectSize(size);

      if (!nodo) {
        /* La taglia non c'e' o non e' selezionabile: e' l'unico caso in cui
           il bottone non deve chiudere niente, altrimenti sembra che non
           sia successo nulla. */
        el.stop.hidden = false;
        el.stop.textContent = T.soldout || '';
        track('apply_fail', { sf_chosen: size });
        return;
      }

      track('apply', { sf_chosen: size });
      closeModal();

      /* IL PUNTO: chiudere la modale e basta faceva sembrare che il bottone
         non facesse niente. La taglia cambia in fondo alla pagina, dove la
         cliente in quel momento non sta guardando. Quindi la vista ci va
         sopra e la pastiglia lampeggia una volta. */
      try { nodo.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      nodo.classList.add('rsa-flash');
      setTimeout(function () { nodo.classList.remove('rsa-flash'); }, 1400);
    });


    /* ---- Guida taglie: MISURE, non pesi ----
       Decisione del proprietario (13/08). Il popup del tema mostrava la
       griglia altezza/peso; ora mostra la tabella misure del capo, quella
       del prodotto che si sta guardando. I numeri arrivano da
       GARMENT_TABLE, generata leggendo la sezione "Misure del capo" del
       template: la stessa fonte, quindi popup e pagina non possono dire
       due cose diverse. */
    function fillSizeGuide() {
      var g = GARMENT_TABLE[ctx.gruppo];
      var box = document.querySelector('#PopupModal-sizing_chart');
      if (!g || !box) return;

      /* 🔴 Il contenitore giusto e' .product-popup-modal__content-info, non
         <modal-dialog>. Infilandola nel dialog la tabella finisce FUORI dal
         pannello bianco e si vede a schermo intero dietro alla pagina: e'
         successo appena le impostazioni tabella del blocco sono state
         svuotate e il tema ha smesso di renderizzare una <table> da
         sostituire. Se il contenitore non si trova, si rinuncia. */
      var host = box.querySelector('.product-popup-modal__content-info') ||
                 box.querySelector('[class*="content-info"]');
      if (!host) return;

      var vecchia = host.querySelector('.rsa-guide');
      if (vecchia) vecchia.remove();

      var lab = function (c) {
        var t = MEASURE_LABEL[c];
        return (t && CFG.lang !== 'it' && t[CFG.lang]) ? t[CFG.lang] : c;
      };
      /* Solo misure: la colonna 'Peso' della scheda e' il peso del capo in
         grammi e in una guida taglie manda solo fuori strada. */
      var tieni = [];
      g.cols.forEach(function (c, i) { if (c !== 'Peso') tieni.push(i); });

      var html = '<table>><thead><tr>';
      tieni.forEach(function (i) { html += '<th>' + esc(lab(g.cols[i])) + '</th>'; });
      html += '</tr></thead><tbody>';
      g.rows.forEach(function (r) {
        if (ctx.available.indexOf(r[0]) === -1) return;
        html += '<tr>';
        tieni.forEach(function (i, k) {
          html += k === 0 ? '<th>' + esc(r[i]) + '</th>' : '<td>' + esc(r[i]) + '</td>';
        });
        html += '</tr>';
      });
      html += '</tbody></table>';

      var d = document.createElement('div');
      d.className = 'rsa-guide';
      d.innerHTML = html.replace('<table>>', '<table>');
      host.insertBefore(d, host.firstChild);
    }

    document.addEventListener('shopify:section:load', paintBar);
    ['change', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, injectProps); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectProps, { once: true });
    }
    paintBar();
    fillSizeGuide();
  }

  /* Guardia di progetto 1: nessun peso di segnale deve MAI coincidere con
     STEP_THRESHOLD. Se coincide, il segnale viene chiesto alla cliente,
     compilato, e poi scartato da `stepFromOffset` senza che nulla lo
     segnali — era il caso della coppa, che valeva 0,5 contro una soglia
     che scartava <= 0,5. Rumorosa di proposito. */
  (function auditPesi() {
    var rotti = Object.keys(CUP_BIAS).filter(function (k) {
      return Math.abs(CUP_BIAS[k]) === STEP_THRESHOLD;
    });
    if (rotti.length && typeof console !== 'undefined') {
      console.error('[rolvea-size-advisor] peso di segnale uguale alla soglia, non spostera mai una taglia: CUP_BIAS.' + rotti.join(', '));
    }
  })();

  /* Guardia di progetto 2: ogni zona che dichiara una misura del corpo deve
     avere il passo corrispondente in BODY_STEP, e ogni misura chiesta alla
     cliente deve essere letta da qualche zona. La v5 chiedeva la vita sui
     capi bottom e non la leggeva mai: e' esattamente il difetto che questo
     controllo rende impossibile ripetere in silenzio. */
  (function auditMisure() {
    var usate = {};
    Object.keys(ZONE_MEASURE).forEach(function (z) {
      var m = ZONE_MEASURE[z];
      if (!m) return;
      usate[m] = true;
      if (BODY_STEP[m] == null && typeof console !== 'undefined') {
        console.error('[rolvea-size-advisor] la zona ' + z + ' chiede "' + m + '" ma BODY_STEP non ce l\'ha');
      }
    });
    window.__rsaMeasuresUsed = usate;
  })();

  /* esposto per il collaudo e per un eventuale riuso */
  window.RolveaSizeAdvisor = {
    recommend: recommend, MATRIX: MATRIX, GARMENT_ZONE: GARMENT_ZONE,
    ZONE_MEASURE: ZONE_MEASURE, I18N: I18N,
    W_COLS: W_COLS, H_ROWS: H_ROWS, CEILING: CEILING,
    H_HARD_LO: H_HARD_LO, H_HARD_HI: H_HARD_HI, init: init
  };

  function boot() { document.querySelectorAll('[data-rsa]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
